<template>
    <div class="container-fluid">
            <div class="row">
              <jobs/>
        </div>
  </div>
</template>

<script>
import jobs from './components/jobs'
export default {
  components: {
      jobs
    },
};
</script>

<style></style>
